export default __webpack_public_path__ + "static/media/xls.210a8000.svg";